export enum SubscrbtionEnumPackagesCodeEnum {
  rise = 'rise',
  newGrowth = 'new_growth',
  newProfessional = 'new_professional',
}
